import React from 'react';
import Card from "components/Card";
import {AppPermissions} from "types/User";
import {AppPermissionsList} from "../../AppPermissionsList";

// Types ----

type PermissionsCardProps = {
  permissions: AppPermissions
  isLoading?: boolean
}

// Component ----

export function AppPermissionsCard({permissions, isLoading}: PermissionsCardProps) {
  return (
    <Card heading="App Permissions" isLoading={isLoading}>
      <AppPermissionsList permissions={permissions} />
    </Card>
  );
}